const adaptTramoProfesional = (tramo) => {
  const { idHonorarioProfesionalAjuste, descripcion, valor } = tramo;

  return {
    id: idHonorarioProfesionalAjuste,
    displayName: descripcion,
    valor,
  };
};

export const adaptTramosProfesionales = (data) => {
  const adaptedData = data?.tramoProfesional?.map((tramo) =>
    adaptTramoProfesional(tramo)
  );

  return adaptedData;
};
